// local url
// export const url = "http://localhost:4066"

// live url
// export const url = "https://artisagaadmin.ebslon.com/api"
export const url = "https://artisaga.com/api"
